import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "price-history-chart" }
const _hoisted_2 = { class: "row g-2 mb-3" }
const _hoisted_3 = { class: "price-history-chart__stat rounded-2 h-100" }
const _hoisted_4 = { class: "small text-muted" }
const _hoisted_5 = { class: "fw-semibold" }
const _hoisted_6 = { class: "small text-muted" }
const _hoisted_7 = {
  key: 0,
  class: "small text-muted mb-2"
}
const _hoisted_8 = { class: "price-history-chart__canvas" }
const _hoisted_9 = { ref: "canvas" }
const _hoisted_10 = { class: "price-history-chart__legend d-flex flex-wrap justify-content-center mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.label,
          class: "col-6 col-md"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.label), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.value), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.note), 1)
          ])
        ]))
      }), 128))
    ]),
    (_ctx.chart.extreme)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", {
            class: "me-1",
            "aria-hidden": "true"
          }, "ⓘ", -1),
          _createTextVNode("Ceny se střídají mezi několika hladinami, nemovitost má nejspíš více souběžných inzerátů. Graf proto ukazuje rozpětí, ve kterém se ceny pohybovaly. ", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("canvas", _hoisted_9, null, 512)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legend, (item) => {
        return (_openBlock(), _createElementBlock("span", {
          key: item.key,
          class: "text-nowrap"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass('price-history-chart__symbol price-history-chart__symbol--' + item.key)
          }, null, 2),
          _createTextVNode(_toDisplayString(item.label), 1)
        ]))
      }), 128))
    ])
  ]))
}